<template>
  <v-container fluid>
    <v-card class="pb-2">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-row align-content="center">
          <v-col
              cols="10"
              align-self="center">
            <v-toolbar-title class="textwithbackground--text">
              {{ $t('Настройки сегмента') }}
            </v-toolbar-title>
          </v-col>
          <v-col cols="2" class="text-right">
            <btn-icon-tip
                icon="edit"
                icon-color="secondaryiconbtn"
                :tip="$t('Редактировать настройки')"
                :disabled="isLoading"
                @click="openEditSegmentSettingsDialog" />
            <edit-segment-settings-dialog
                v-if="editSegmentSettingsDialog.show"
                :dialog-prop="editSegmentSettingsDialog"
                @close="closeDialog('editSegmentSettingsDialog')" />
          </v-col>
        </v-row>
      </v-toolbar>
      <v-row class="text-left pa-2 ma-2 ml-4">
        <v-col>
          <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
            <v-col cols="12">
              <v-progress-linear :active="isLoading" color="loader" indeterminate />
            </v-col>
            <v-col class="mx-1">
              <general-error v-if="!!generalError" />
            </v-col>
          </v-row>
          <v-row
              v-if="isAdmin">
            <template v-for="prop in segmentProps">
              <text-view
                  v-if="prop.dataType === 'string'"
                  :key="prop.propertyName"
                  multiline
                  :display="getPropValue(prop)"
                  :label="$t(prop.description)" />
              <date-view
                  v-if="prop.dataType === 'dateTime'"
                  :key="prop.propertyName"
                  multiline
                  :display="getPropValue(prop)"
                  :label="$t(prop.description)" />
            </template>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

  import EditSegmentSettingsDialog from '@/components/pages/admin/SystemSettings/EditSegmentSettingsDialog.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'

  export default {
    components: {
      TextView,
      GeneralError,
      BtnIconTip,
      DateView,
      EditSegmentSettingsDialog
    },
    data () {
      return {
        isLoading: false,
        editSegmentSettingsDialog: {
          settings: null,
          callback: null,
          show: false
        }
      }
    },
    computed: {
      segmentProps () {
        return this.configuration.segment || []
      }
    },
    created () {
      Promise.all([
        this.getConfiguration()
      ])
    },
    methods: {
      getPropValue: function (sp) {
        return sp.dataType === 'string'
          ? sp.stringValue
          : sp.dataType === 'dateTime'
            ? sp.dateValue
            : null
      },
      openEditSegmentSettingsDialog: function () {
        this.editSegmentSettingsDialog.settings = this.segmentProps
        this.editSegmentSettingsDialog.callback = this.getConfiguration
        this.editSegmentSettingsDialog.show = true
      }
    }
  }
</script>
